import { Grid, useMediaQuery } from "@mui/material";
import { onClosePopUp } from "redux/slices";
import { useAppDispatch, useImagePath } from "hooks";
import headerImg from "assets/featured-deals/popup/bg.jpg";
import {
	bannerStyle,
	Body,
	Button,
	Container,
	Header,
	textStyle,
	Title
} from "./styles";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import BonusFlag from "components/BonusFlag";
import { wrapperStyle } from "./styles";

interface LoyaltyPointsInfoProps {}

export const LoyaltyPointsInfo: React.FC<LoyaltyPointsInfoProps> = () => {
	const dispatch = useAppDispatch();
	const { getImage } = useImagePath("local");
	const headImageUrl = getImage(headerImg);
	const isPortrait = useMediaQuery("(orientation: portrait)");
	const scale = useCalculateScale(393, 393);

	const onClose = () => {
		dispatch(onClosePopUp());
	};

	return (
		<Container scale={scale}>
			<CloseIconButton onClose={onClose} />
			<Header data-image={headImageUrl}></Header>
			<BonusFlag
				text={"Web Exclusive"}
				position="left"
				wrapperStyle={wrapperStyle}
				bannerStyle={bannerStyle}
				textStyle={textStyle}
			/>
			<Body>
				<Title>
					Earn Loyalty Points with every Web Shop purchase and redeem them for
					exciting in-game items!
				</Title>

				<Grid container spacing={isPortrait ? 2 : 1}>
					<Grid item xs={12} display="flex" justifyContent="center">
						<Button
							variant="contained"
							themeColor="secondary"
							sx={{ minWidth: { xs: "100%", sm: "100%" } }}
							onClick={() => onClose()}
						>
							Continue Shopping
						</Button>
					</Grid>
				</Grid>
			</Body>
		</Container>
	);
};
